export default "<div class=\"loading\">\r\n  <img src=\"assets/images/logo-black.svg\" alt=\"Cargando...\" />\r\n  <p>{{ text }}</p>\r\n</div>\r\n";